(ns iris.posts.views.display-top-bar
  (:require
   [cemerick.url :as cemerick.url]
   [re-frame.core :as re-frame]
   [iris.styles.posts :as $posts]))


(defn display-top-bar
  ([qp] (display-top-bar qp {}))
  ([qp {:keys [label? refresh-row?]
        :or {label? true
             refresh-row? false}}]
   (let [refresh-btn [:div.btn-group.btn-group-sm
                      {:role "group"
                       :style {:margin "5px"}}
                      [:button.btn.btn-default.btn-success
                       {:on-click #(re-frame/dispatch [:iris.route-data.events/force-sync-route-data])
                        :title "Refresh posts"}
                       [:span {:class "glyphicon glyphicon-refresh"}]
                       [:span {:class "global-refresh-btn-label"} " Refresh"]]]]
     [:div#display-top-bar
      {:style {:text-align "center" :margin-top "10px"}}
      [:div#display-switches.container-fluid
       (when label?
         [:span {:class $posts/$filter-display-labels}
          "\n\t\tDisplay:\n\t\t\n\n"])
       [:div.btn-group.btn-group-sm
        {:role "group"
         :style {:margin "5px"}}
        [:a.btn
         {:title "Display processed/censored text"
          :href (str "?" (cemerick.url/map->query (dissoc qp :raw)))
          :class (if (not= (:raw qp) "yes") "btn-primary" "btn-default")}
         "processed"]
        [:a.btn
         {:title "Display text as submitted"
          :href (str "?" (cemerick.url/map->query (conj qp {:raw "yes"})))
          :class (if (= (:raw qp) "yes") "btn-primary" "btn-default")}
         "raw"]]

       [:div.btn-group.btn-group-sm
        {:role "group"
         :style {:margin "5px"}}
        [:a.btn
         {:href (str "?" (cemerick.url/map->query (dissoc qp :excerpt)))
          :class (if (not= (:excerpt qp) "yes") "btn-primary" "btn-default")
          :title "Display full text"}
         "full text"]
        [:a.btn
         {:href (str "?" (cemerick.url/map->query (conj qp {:excerpt "yes"})))
          :class (if (= (:excerpt qp) "yes") "btn-primary" "btn-default")
          :title "Display excerpt"}
         "excerpt"]]

       [:div.btn-group.btn-group-sm
        {:role "group"
         :style {:margin "5px"}}
        [:a.btn
         {:title "list view"
          :href (str "?" (cemerick.url/map->query (dissoc qp :layout)))
          :class (if (nil? (:layout qp)) "btn-primary" "btn-default")}
         "list"]
        [:a.btn
         {:title "Display table view"
          :href (str "?" (cemerick.url/map->query (conj qp {:layout "table"})))
          :class (if (= (:layout qp) "table") "btn-primary" "btn-default")}
         "table"]
        [:a.btn
         {:title "Display table 2 view"
          :href (str "?" (cemerick.url/map->query (conj qp {:layout "table2"})))
          :class (if (= (:layout qp) "table2") "btn-primary" "btn-default")}
         "table2"]]

       (if refresh-row?
         [:div {:style {:display "block"}} refresh-btn]
         refresh-btn)]])))
